import { z } from 'zod';

export const NotificationsModesZod = z.union([
    z.literal('notifyAndShareWithAdvocates'),
    z.literal('notifyAndShareWithBeneficiaries'),
    z.literal('notifyAndShareWithParticipants'),
    z.literal('notifyOnlyAdvocates'),
    z.literal('notifyOnlyBeneficiaries'),
    z.literal('notifyOnlyParticipants'),
    z.literal('customized'),
    z.literal('dontNotify'),
]);

export type NotificationsModes = z.infer<typeof NotificationsModesZod>;
